import React from 'react';
import ReactDOM from 'react-dom';
import 'whatwg-fetch';

import App from './src/js/App';
import './index.scss';

let districts = fetch('assets/data/council-districts.json').then(r => r.json());
let races = fetch('assets/data/races.json').then(r => r.json());

Promise.all([districts, races])
  .then(([d, r]) => {
    ReactDOM.render(
      <App districts={d} races={r} />,
      document.getElementById('root')
    );
  });



// WEBPACK FOOTER //
// ./app/index.js